<template>
  <suspense>
    <ContentfulDynamicRenderer v-if="visibleVariant" v-bind="visibleVariant.fields.content"></ContentfulDynamicRenderer>
  </suspense>
</template>

<script>
import ContentfulDynamicRenderer from '../Fields/ContentfulDynamicRenderer.vue';
import useExperiment from '@/compositions/useExperiment.js';
import { useContentful, contentfulProps } from '@/compositions/useContentful.js';
import useAsyncComputed from '@/compositions/useAsyncComputed.js';

import {
  computed,
} from 'vue';

export default {
  components: {
    ContentfulDynamicRenderer,
  },
  props: contentfulProps,
  async setup(p, c) {
    const { data, resolveEntry, init } = useContentful('experiment', p, c, { resolveDepth: 1 });
    const { loaded, getFeatureVariant } = useExperiment();

    const [variants, loadVariants, initVariants] = useAsyncComputed(async () => Promise.all(data.value.variants.map((v) => resolveEntry(v, 1))));

    const activeVariantName = computed(() => {
      if (!data.value) {
        return '';
      }
      return getFeatureVariant(data.value.featureId);
    });

    const currentVariantName = computed(() => {
      if (!data.value) {
        return null;
      }
      if (!loaded.value || !activeVariantName.value) {
        return data.value.defaultVariant;
      }
      return getFeatureVariant(data.value.featureId);
    });

    const visibleVariant = computed(() =>
      variants.value?.find((v) => v.fields.variant === currentVariantName.value),);

    await Promise.all([init, initVariants]);

    return {
      data,
      visibleVariant,
      currentVariantName,
      activeVariantName,
      variants,
    };
  },
};
</script>

<style lang="postcss"></style>
